var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIsCriticalResult({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.59256 1.68637C8.36189 1.25037 7.64456 1.25037 7.41389 1.68637L1.41389 13.0197C1.35988 13.1213 1.33311 13.2351 1.33617 13.3501C1.33924 13.4651 1.37205 13.5774 1.4314 13.6759C1.49075 13.7745 1.57461 13.856 1.67483 13.9125C1.77504 13.969 1.88818 13.9986 2.00323 13.9984H14.0032C14.1182 13.9986 14.2313 13.9691 14.3314 13.9126C14.4316 13.8561 14.5154 13.7747 14.5746 13.6762C14.6339 13.5777 14.6667 13.4655 14.6697 13.3505C14.6727 13.2356 14.6459 13.1219 14.5919 13.0204L8.59256 1.68637ZM8.66989 11.9984H7.33656V10.665H8.66989V11.9984ZM7.33656 9.33171V5.99837H8.66989L8.67056 9.33171H7.33656Z",
    fill: "#E74C3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsCriticalResult);
export default __webpack_public_path__ + "static/media/isCriticalResult.ac4ee5ccc8faaebc0f7716ae7434c885.svg";
export { ForwardRef as ReactComponent };